export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export interface SortParameter {
  sortBy: string;
  direction: SortDirection;
}

export abstract class SortService {
  static sortByMultiple(items: any[], sortParameter: SortParameter[]): any[] {
    return items.sort((a, b) => {
      for (const sortParam of sortParameter) {
        const sortByAttr = sortParam.sortBy;
        const compareResult = SortService.compare(
          a[sortByAttr],
          b[sortByAttr],
          sortParam.direction
        );
        if (compareResult !== 0) {
          return compareResult;
        }
      }
      return 0;
    });
  }

  static sort(items: any[], direction: SortDirection, sortBy?: string): any[] {
    return items.sort((a, b) => {
      // Sorty by property or sort list
      let valueA = sortBy ? a[sortBy] : a;
      let valueB = sortBy ? b[sortBy] : b;

      // Lowercase strings
      valueA = typeof valueA === 'string' ? valueA.toLowerCase() : valueA;
      valueB = typeof valueB === 'string' ? valueB.toLowerCase() : valueB;

      return SortService.compare(valueA, valueB, direction);
    });
  }

  private static compare(valueA: any, valueB: any, direction: SortDirection): number {
    let comparatorResult = 0;
    if (valueA != null && valueB != null) {
      if (valueA > valueB) {
        comparatorResult = 1;
      } else if (valueA < valueB) {
        comparatorResult = -1;
      }
    } else if (valueA != null) {
      comparatorResult = 1;
    } else if (valueB != null) {
      comparatorResult = -1;
    }
    return comparatorResult * (direction === SortDirection.Ascending ? 1 : -1);
  }
}
